import * as React from "react";

import { Section, SectionTitle } from "../../Common";

import { PresentationThemeProduct } from "../model";

import { ProductSlider } from "./product-slider";

interface RecommendedForYouProps {
  products?: PresentationThemeProduct[];
}

export const RecommendedForYou: React.FunctionComponent<
  RecommendedForYouProps
> = (props) => {
  return (
    <Section className="recommended-for-you" mobileFullWidth>
      <SectionTitle>Recommended for You</SectionTitle>

      {props.products && <ProductSlider products={props.products} />}
    </Section>
  );
};
